
import { TranslationRecord } from '../../types';

export const company: TranslationRecord = {
  // Company Information
  companyInfo: 'Company Information',
  companyName: 'Company Name: Christos Ath. Petkakis & Co.',
  vatId: 'VAT ID',
  vatNumber: 'EL092615293',
  address: 'Address',
  companyAddress: '13 Ernestou Emprar Street, 4th Floor, Thessaloniki 54625',
  gemi: 'Greek Commercial Registry',
  gemiNumber: '038228205000',
};
